export default function getDragDropzonePadding(itemId: string) {
  const element = document?.getElementById(itemId);
  let computedStyles: CSSStyleDeclaration;
  let marginTop: number;
  let marginBottom: number;
  let marginLeft: number;
  let marginRight: number;
  if (element) {
    computedStyles = window?.getComputedStyle(element);
    marginTop = parseInt(computedStyles?.marginTop || "0");
    marginBottom = parseInt(computedStyles?.marginBottom || "0");
    marginLeft = parseInt(computedStyles?.marginLeft || "0");
    marginRight = parseInt(computedStyles?.marginRight || "0");
  }

  return {
    top: marginTop,
    bottom: marginBottom,
    left: marginLeft,
    right: marginRight,
    totalY: marginTop + marginBottom,
    totalX: marginLeft + marginRight,
  };
}

export const getHeightCalc = (
  padding: {
    top?: number;
    bottom?: number;
  },
  inverted = false
) => {
  const hasVerticalPadding = padding.top || padding.bottom;
  const top = padding.top ?? 0;
  const bottom = padding.bottom ?? 0;

  if (!hasVerticalPadding) return "100%";

  return inverted ? `calc(100% - ${top}px - ${bottom}px)` : `calc(100% + ${top}px + ${bottom}px)`;
};

export const getWidthCalc = (padding: { left?: number; right?: number }) => {
  const hasHorizontalPadding = padding.left || padding.right;
  const left = padding.left ?? 0;
  const right = padding.right ?? 0;

  return hasHorizontalPadding ? `calc(100% + ${left}px + ${right}px)` : "100%";
};
